import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductListService {

  private productListSource = new BehaviorSubject<any[]>([]);
  productList$ = this.productListSource.asObservable();

  setProductList(activelist: any[],inActivelist: any[]) {
    let products = [...activelist,...inActivelist]
    this.productListSource.next(products);
  }
}
